import {library, dom} from '@fortawesome/fontawesome-svg-core';

// Brands icons
import {faFacebookF} from '@fortawesome/free-brands-svg-icons/faFacebookF';
import {faLinkedinIn} from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import {faYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube';
import {faInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram';
import {faTwitter} from '@fortawesome/free-brands-svg-icons/faTwitter';

// Solid icons
import {faCircle} from '@fortawesome/pro-solid-svg-icons/faCircle'
import {faFlag} from '@fortawesome/pro-solid-svg-icons/faFlag'
import {faQuoteLeft} from '@fortawesome/pro-solid-svg-icons/faQuoteLeft';
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes'

// Regular icons
import {faPhoneAlt} from '@fortawesome/pro-regular-svg-icons/faPhoneAlt'
import {faLongArrowLeft} from '@fortawesome/pro-regular-svg-icons/faLongArrowLeft'
import {faLongArrowRight} from '@fortawesome/pro-regular-svg-icons/faLongArrowRight'
import {faCheck} from '@fortawesome/pro-regular-svg-icons/faCheck'
import {faPlayCircle} from '@fortawesome/pro-regular-svg-icons/faPlayCircle'

// Light icons
import {faGlobe} from '@fortawesome/pro-light-svg-icons/faGlobe'
import {faPhone} from '@fortawesome/pro-light-svg-icons/faPhone'
import {faFileDownload} from '@fortawesome/pro-light-svg-icons/faFileDownload'


library.add(faFacebookF, faTwitter, faLinkedinIn, faYoutube, faInstagram, faPhoneAlt, faGlobe, faLongArrowLeft, faLongArrowRight, faCheck, faCircle, faFlag, faQuoteLeft, faPlayCircle, faTimes, faPhone, faFileDownload);
dom.watch();